import { Check } from "lucide-react";
import { useLang } from "@/i18n";

const MAIN_STEPS = [
  { key: "submitted", label: "Enviada" },
  { key: "deposit_paid", label: "Depósito" },
  { key: "bidding", label: "Pujando" },
  { key: "result", label: "Resultado" },
  { key: "payment_due", label: "Pago saldo" },
  { key: "paid", label: "Pagado" },
  { key: "in_transit", label: "En tránsito" },
  { key: "delivered", label: "Entregado" },
];

const STATUS_INDEX = {
  submitted: 0,
  deposit_paid: 1,
  bidding: 2,
  won: 3,
  lost: 3,
  payment_due: 4,
  paid: 5,
  in_transit: 6,
  delivered: 7,
  refund_pending: 3,
  refunded: 3,
  cancelled: 0,
};

export default function StatusTracker({ status }) {
  const { t } = useLang();
  const current = STATUS_INDEX[status] ?? 0;
  const lost = ["lost", "refund_pending", "refunded"].includes(status);

  return (
    <div data-testid="status-tracker" className="w-full overflow-x-auto">
      <div className="flex items-center min-w-[640px]">
        {MAIN_STEPS.map((step, i) => {
          const done = i < current;
          const active = i === current;
          const isResult = step.key === "result";
          const label = isResult ? (status === "won" ? t("Ganada") : lost ? t("Perdida") : t("Resultado")) : t(step.label);
          const resultColor = isResult && active ? (status === "won" ? "bg-[#22C55E] border-[#22C55E]" : lost ? "bg-red-500 border-red-500" : "") : "";
          return (
            <div key={step.key} className="flex items-center flex-1 last:flex-none">
              <div className="flex flex-col items-center gap-2">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center border-2 transition-colors duration-300 ${
                    done
                      ? "bg-[#22C55E] border-[#22C55E] text-white"
                      : active
                      ? `${isResult && (status === "won" || lost) ? resultColor + " text-white" : "bg-[#2563EB] border-[#2563EB] text-white"}`
                      : "border-slate-600 text-slate-500"
                  }`}
                >
                  {done ? <Check className="w-4 h-4" strokeWidth={2.5} /> : <span className="text-xs font-bold">{i + 1}</span>}
                </div>
                <span className={`text-[11px] whitespace-nowrap ${active ? "text-white font-semibold" : done ? "text-emerald-400" : "text-slate-500"}`}>
                  {label}
                </span>
              </div>
              {i < MAIN_STEPS.length - 1 && (
                <div className={`h-0.5 flex-1 mx-2 -mt-6 transition-colors duration-300 ${i < current ? "bg-[#22C55E]" : "bg-slate-700"}`} />
              )}
            </div>
          );
        })}
      </div>
      {lost && (
        <p className="text-xs text-amber-400 mt-3" data-testid="refund-note">
          {t("Subasta perdida — tu depósito será reembolsado (menos la cuota de procesamiento divulgada).")}
        </p>
      )}
    </div>
  );
}
